let marketplaceImportBusy = false;

export function setMarketplaceImportBusy(busy: boolean) {
  marketplaceImportBusy = busy;
}

export function assertMarketplaceImportIdle() {
  if (marketplaceImportBusy) throw new Error("Wait for the marketplace import to finish before switching workspaces.");
}
